import React from 'react';
import { useQuery } from '@apollo/client';
import environmentVariablesQuery
  from './graphql/queries/environmentVariablesQuery';
import isQueryReady from './utils/isQueryReady';
import EnvironmentVariablesContext
  from './contexts/EnvironmentVariablesContext';
import Loading from "./Loading";
import mapIntoKeyValue from './utils/mapIntoKeyValue';

export default function EnvironmentVariableProvider({
  children,
}) {
  const environmentVariables = useQuery(environmentVariablesQuery);

  return (
    <React.Fragment>
      {isQueryReady(environmentVariables) ? (
        <EnvironmentVariablesContext.Provider value={mapIntoKeyValue(environmentVariables.data.environmentVariables)}>
          {children}
        </EnvironmentVariablesContext.Provider>
      ) : (
        <Loading label="Loading environment variables…" />
      )}
    </React.Fragment>
  )
}
